export const RESERVATION_SPACE_TYPES = {
  DEFAULT: "DEFAULT", // 기존 회의실
  SHOWER: "SHOWER", // 샤워실
} as const;

export type reservationSpaceType = keyof typeof RESERVATION_SPACE_TYPES;

export const convertReservationTypeToLabel = (
  spaceType: reservationSpaceType
) => {
  return spaceType === RESERVATION_SPACE_TYPES.DEFAULT
    ? "기본(회의실)"
    : "샤워실";
};

export const RESERVATION_CLEAN_TIME_MINUTE = 30; // 30분
export const RESERVATION_SHOWER_ROOM_TODAY_GAP_MINUTE = 90; // 1시간 30분
